"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var animate_1 = __importDefault(require("relements/build/esm/layouts/animate"));
var Arrow_svg_1 = __importDefault(require("./Arrow.svg"));
var wrapperStyles = function (props) {
    return {
        padding: '0',
        width: '100%',
        columnGap: 25,
        overflowX: 'scroll',
        scrollBehavior: 'smooth',
        borderTop: "1px solid " + props.theme.colors.grey.haptik,
        borderBottom: "1px solid " + props.theme.colors.grey.haptik,
        scrollSnapType: 'x mandatory',
        '&::-webkit-scrollbar': {
            background: 'transparent',
            '-webkit-appearance': 'none',
            width: 0,
            height: 0,
        },
    };
};
var ContentWrapper = styled_components_1["default"](box_1["default"])(wrapperStyles);
var arrowIconStyles = function (props) {
    var active = props.active, direction = props.direction, theme = props.theme, visible = props.visible;
    return {
        borderRadius: "0 " + theme.radii.lg + "px " + theme.radii.lg + "px 0px",
        borderLeftWidth: '0px !important',
        height: 'auto',
        border: "1px solid " + props.theme.colors.grey.haptik,
        transform: "rotate(" + (direction === 'right' ? '0' : '180deg') + ") translateX(-1px)",
        justifyContent: 'end',
        alignItems: 'center',
        cursor: 'pointer',
        paddingRight: visible ? theme.space.md + theme.space.sm : 0,
        paddingLeft: visible ? theme.space.sm : 0,
        width: visible ? theme.space.md + theme.space.sm : theme.space.lg,
        background: active ? '#ffffff' : 'transparent',
        transition: 'all 0.3s ease',
        '& > div > div': {
            width: 6,
            height: 'auto',
        },
    };
};
var Arrow = styled_components_1["default"](box_1["default"])(arrowIconStyles);
var tabWrapperStyles = function (props) {
    var active = props.active, theme = props.theme, arrowsPresent = props.arrowsPresent, error = props.error;
    return {
        padding: '7px 0',
        position: 'relative',
        cursor: 'pointer',
        transform: "translateX(" + (arrowsPresent === 'right' ? '-32px' : '0') + ")",
        transition: 'all 0.3s ease',
        scrollSnapAlign: 'start',
        '&::before': {
            position: 'absolute',
            content: '""',
            height: 5,
            opacity: error ? 1 : 0,
            width: 5,
            borderRadius: '100%',
            top: 6,
            right: -7,
            background: theme.colors.red.haptik,
            transition: 'opacity 0.3s ease',
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            height: active ? 2 : 0,
            opacity: active ? 1 : 0,
            width: '100%',
            borderRadius: theme.radii.sm + "px " + theme.radii.sm + "px 0 0",
            bottom: 0,
            background: theme.colors.blue.haptik,
            transition: 'all 0.3s ease',
        },
    };
};
var TabWrapper = styled_components_1["default"](box_1["default"])(tabWrapperStyles);
var ScrollableLanguageTabs = function (_a) {
    var currentBotSaysLanguage = _a.currentBotSaysLanguage, onLanguageChange = _a.onLanguageChange, supportedLanguages = _a.supportedLanguages, allHybridLanguages = _a.allHybridLanguages, errorLanguages = _a.errorLanguages;
    var wrapperRef = react_1.useRef(null);
    var activeRef = react_1.useRef(null);
    var _b = react_1.useState(0), scrollX = _b[0], setScrollX = _b[1];
    var _c = react_1.useState(false), scrollEnd = _c[0], setScrollEnd = _c[1];
    // Determines when to hide/show arrows
    var scrollCheck = react_1.useCallback(function (viaHandleScroll) {
        if (viaHandleScroll === void 0) { viaHandleScroll = false; }
        if (!viaHandleScroll)
            setScrollX(wrapperRef.current.scrollLeft);
        var scrollEndState = Math.floor(wrapperRef.current.scrollWidth - wrapperRef.current.scrollLeft) <= wrapperRef.current.offsetWidth;
        setScrollEnd(scrollEndState);
    }, []);
    react_1.useEffect(function () {
        scrollCheck();
    }, []);
    var handleScroll = function (offset) {
        wrapperRef.current.scrollLeft += offset;
        setScrollX(scrollX + offset);
        scrollCheck(true);
    };
    return (react_1["default"].createElement(box_1["default"], { style: { padding: 0 }, "data-testid": "gc_language_tabs_wrapper" },
        react_1["default"].createElement(Arrow, { direction: "left", onClick: function () { return (scrollX !== 0 ? handleScroll(-70) : null); }, "data-testid": "gc_language_tabs_left_scroll", visible: scrollX !== 0 },
            react_1["default"].createElement(animate_1["default"], { entry: "fade-left", exit: "fade-right", active: scrollX !== 0 },
                react_1["default"].createElement(icon_1["default"], { src: Arrow_svg_1["default"] }))),
        react_1["default"].createElement(ContentWrapper, { ref: wrapperRef, "data-testid": "gc_language_tabs" }, supportedLanguages.map(function (tab) {
            var active = tab.path === currentBotSaysLanguage;
            return (react_1["default"].createElement(TabWrapper, { active: active, key: tab.path, error: errorLanguages.includes(tab.path), value: tab.path, ref: active ? activeRef : null, "data-testid": "gc_language_tabs_tab_" + tab.path, 
                // eslint-disable-next-line consistent-return
                onClick: function () {
                    var _a, _b;
                    if (active)
                        return null;
                    var botSaysLanguage = tab.path;
                    if (activeRef === null || activeRef === void 0 ? void 0 : activeRef.current) {
                        setTimeout(function () {
                            activeRef.current.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest',
                            });
                        }, 50);
                    }
                    onLanguageChange(botSaysLanguage, allHybridLanguages[botSaysLanguage].length > 1
                        ? (_a = allHybridLanguages[botSaysLanguage][0]) === null || _a === void 0 ? void 0 : _a.script : botSaysLanguage, allHybridLanguages[botSaysLanguage].length > 1
                        ? (_b = allHybridLanguages[botSaysLanguage][0]) === null || _b === void 0 ? void 0 : _b.name : tab.title);
                } },
                react_1["default"].createElement(text_1["default"], { variant: "body.md", color: active ? 'blue.haptik' : 'black.haptik' }, tab.title)));
        })),
        react_1["default"].createElement(Arrow, { direction: "right", onClick: function () { return (!scrollEnd ? handleScroll(70) : null); }, "data-testid": "gc_language_tabs_right_scroll", visible: !scrollEnd },
            react_1["default"].createElement(animate_1["default"], { entry: "fade-right", exit: "fade-left", active: !scrollEnd },
                react_1["default"].createElement(icon_1["default"], { src: Arrow_svg_1["default"] })))));
};
exports["default"] = ScrollableLanguageTabs;
